module.exports = __webpack_public_path__ + "img/icon_channel_hot.98364e8d.png";